import { render, staticRenderFns } from "./item_records.vue?vue&type=template&id=f54b9a50&scoped=true&"
import script from "./item_records.vue?vue&type=script&lang=js&"
export * from "./item_records.vue?vue&type=script&lang=js&"
import style0 from "./item_records.vue?vue&type=style&index=0&id=f54b9a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54b9a50",
  null
  
)

export default component.exports